const ClientInfo = ({ client }) => {
  return (
    <div className="flex items-center justify-center p-4 bg-secondary rounded-lg shadow-md transition-transform duration-300 hover:scale-105 h-24">
      <img
        src={client.logo}
        alt={`${client.name} logo`}
        className="max-h-16 max-w-full object-contain"
      />
    </div>
  );
};

export default ClientInfo;
